import * as t from './actionTypes';

const initialState = { isLoading: false, news: [] };

const newsReducer = (state = initialState, action) => {

  switch (action.type) {
    case t.SET_BUSY:
      return Object.assign({}, state, { isLoading: true });

    case t.UNSET_BUSY:
      return Object.assign({}, state, { isLoading: false });

    case t.NEWS_LOAD_SUCCESS:
      let { news } = action;
      let value = news;
      if (news) {
        if (!Array.isArray(news)) {
          value = Object.keys(news).map(id => ({
            ...news[id],
            id,
          }));
        }
        return ({
          ...state,
          news: value,
        })
      }
      else {
        return ({
          ...state,
          news: value,
        })
      }
    default:
      return state;
  }
};

export default newsReducer;
